export default __webpack_public_path__ + "static/media/umang.95320a90.png";